import { useState, useEffect } from "react";
import { WifiOff } from "lucide-react";

export function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline  = () => setIsOffline(false);
    window.addEventListener("offline", goOffline);
    window.addEventListener("online",  goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online",  goOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="flex items-center gap-2 px-4 py-2 bg-destructive text-destructive-foreground text-sm font-medium shrink-0 z-20">
      <WifiOff className="w-4 h-4 shrink-0" />
      <span>No internet connection — updates will fail until you reconnect</span>
    </div>
  );
}
